import { useEffect } from "react";

/**
 * Hook global para atajos de teclado en diálogos/modales de MUI.
 * Se monta UNA VEZ en App.js y detecta automáticamente si hay un Dialog/Modal abierto.
 * - Escape → click en el botón de Cancelar/Cerrar más cercano
 * - Enter  → click en el botón de Confirmar/Aceptar/Guardar más cercano
 */
export default function useGlobalDialogKeyboard() {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Detectar si hay un dialog/modal abierto (MUI usa estas clases)
      const dialog = document.querySelector(
        '.MuiDialog-root, .MuiModal-root, [role="dialog"], [role="presentation"]'
      );
      if (!dialog) return;

      // Encontrar el contenedor más interno del modal (el paper/box con contenido)
      const container = dialog.querySelector('.MuiDialog-container, .MuiBox-root') || dialog;

      // No interceptar en textarea
      if (e.target.tagName === "TEXTAREA") return;

      if (e.key === "Escape") {
        const closeBtn =
          container.querySelector('button[aria-label="close"]') ||
          findButtonByText(container, ["cancelar", "cerrar", "volver"]);
        if (closeBtn && !closeBtn.disabled) {
          e.preventDefault();
          e.stopPropagation();
          closeBtn.click();
        }
        return;
      }

      if (e.key === "Enter") {
        const confirmBtn =
          findButtonByText(container, [
            "confirmar", "aceptar", "guardar", "siguiente", "crear",
            "confirmar operación", "confirmar y continuar",
            "continuar a confirmación", "guardar y seguir",
            "confirmar pedido", "actualizar",
          ]);
        if (confirmBtn && !confirmBtn.disabled) {
          e.preventDefault();
          e.stopPropagation();
          confirmBtn.click();
        }
        return;
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, []);
}

function findButtonByText(container, textOptions) {
  const buttons = container.querySelectorAll("button");
  for (const btn of buttons) {
    const text = btn.textContent?.toLowerCase().trim() || "";
    if (textOptions.some((opt) => text.includes(opt))) {
      return btn;
    }
  }
  return null;
}
